// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__OJ5_X","consentsList":"PatientConsents_consentsList__3U4lz","consentsListEmpty":"PatientConsents_consentsListEmpty__1GzUv"};